import moment, { Moment } from 'moment';
import React, { useState } from "react";
import { HighlightOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row, Select, DatePicker, Button } from "antd";
import locale from 'antd/es/date-picker/locale/zh_CN';

import { downLoadAuditList, GetProjectCenter, GetTenantSelects } from "../../../../../../services/dct/DctService";

import { QueryParams, useAccoutContext } from "../provider";
import MarkModal from '../mark-modal';

import clsName from './index.module.scss'

const { Item } = Form;
const { RangePicker } = DatePicker
const { Option } = Select

const colCols = {
  span: 6
}
const fieldCols = {
  labelCol: {
    span: 5
  },
  wrapperCol: {
    span: 19
  }
}

const statusOptions = [
  {label: '全部', value: ''},
  {label: '未完成', value: '0'},
  {label: '已完成', value: '1'},
]

const auditOptions = [
  {label:'全部', value: ''},
  {label:'待审核', value: '1'},
  {label:'通过', value: '2'},
  {label:'未通过', value: '3'}
]

const warnOptions = [
  {label:'全部', value: ''},
  {label: '临期', value: '2'},
  {label: '超期', value: '3'}
]

interface CenterRecord {
  name: string
  code: string
}
interface TenantRecord {
  name: string
  code: string
  selects: CenterRecord[]
}

// 排除特殊的筛选条件 startTime,endTime,projectList
interface ConditionParams extends Omit<QueryParams, 'startTime' | 'endTime' | 'projectList'> {
  projectCode: string
  rangeTime: [Moment, Moment]
}

type ConditionParamsType = keyof Omit<QueryParams, 'startTime' | 'endTime' | 'projectList'>

const tenantMap: {[key: string]: CenterRecord[]} = {}

interface ConditionProps {

}
const Condition: React.FC<ConditionProps> = () => {

  const [ form ] = Form.useForm<ConditionParams>();

  const { queryParams, setQueryParams, showMore, handleToggle } = useAccoutContext()

  const [tenantOptions, setTenantOptions] = useState<TenantRecord[]>([]);
  const [projectOptions, setProjectOptions] = useState<CenterRecord[]>([]);
  const [centerOptions, setCenterOptions] = useState<CenterRecord[]>([]);

  const [visibleMarkModal, setVisibleMarkModal] = useState(false)

  const [downloading, setDownloading] = useState(false)

  const handleFetchTenantData = async (open: boolean) => {
    if (tenantOptions.length > 0 || !open) {
      return
    }

    const { code, data }: {code: number, data: TenantRecord[]} = await GetTenantSelects()

    if (code === 0) {
      (data || []).map(item => {
        tenantMap[item.code] = item.selects;
      })
      setTenantOptions(data || [])
    }
  }

  const handleTenantChange = (value: string) => {
    form.setFieldsValue({
      projectCode: '',
      centerCode: '',
    })

    setProjectOptions(tenantMap[value] || [])
    setCenterOptions([])
  }

  const handleProjectChange = async (value: string) => {
    const { code, data } = await GetProjectCenter({
      projectCode: value
    })

    if (code === 0) {
      setCenterOptions(data || [])
    }
    
    form.setFieldsValue({
      centerCode: '',
    })
  }

  const handleDownload = async()=> {
    setDownloading(true)

    const res = await downLoadAuditList(queryParams)

    setDownloading(false)

    const url = window.URL.createObjectURL(new Blob([res]));
    const a = document.createElement('a');
    a.href = url;
    a.download = '结算审核数据.xlsx';
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  const handleSubmit = ({rangeTime, projectCode, ...params}: ConditionParams)=> {

    const queryParams: QueryParams = {}

    if (projectCode) {
      queryParams.projectList = [projectCode]
    }

    if (Array.isArray(rangeTime)) {
      const [startTime, endTime] = rangeTime
      queryParams.startTime = moment(startTime).format('YYYY-MM-DD')
      queryParams.endTime = moment(endTime).format('YYYY-MM-DD')
    }

    for(const name in params) {
      const key = name as ConditionParamsType
      if (params[key]) {
        queryParams[key] = params[key]
      }
    }

    setQueryParams(queryParams)
  }

  const handleClear = ()=> {
    setQueryParams({})

    form.resetFields()
  }

  return (
    <div className={clsName.wrapper}>
      <Form
          form={form}
          size='middle'
          onFinish={handleSubmit}
          initialValues={{
            account: "",
            auditState: "",
            warningState: "",
            tenantCode: "",
            projectCode: "",
            centerCode: "",
          }}
        >
          <Row gutter={8}>
            <Col {...colCols}>
              <Item {...fieldCols} name="taskId" label="任务ID">
                <Input placeholder="请输入任务ID"/>
              </Item>
            </Col>
            <Col {...colCols}>
              <Item {...fieldCols} name="subjectCode" label="任务编码">
                <Input placeholder="请输入任务编码"/>
              </Item>
            </Col>
            <Col {...colCols}>
              <Item {...fieldCols} name="createUser" label="上传人">
                <Input  placeholder="请输入上传人账号"/>
              </Item>
            </Col>
            <Col {...colCols}>
              <Button htmlType='submit' type="primary">搜索</Button>
              <Button onClick={handleClear} style={{marginLeft: 10}}>重置</Button>
              <Button onClick={handleDownload} loading={downloading}  type="link" style={{marginLeft: 10}}>导出数据</Button>
              <Button onClick={handleToggle} type="link">更多</Button>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col {...colCols}>
              <Item {...fieldCols} name="account" label="完成状态">
                <Select options={statusOptions} size='middle'/>
              </Item>
            </Col>
            <Col {...colCols}>
              <Item {...fieldCols} name="auditState" label="审核状态">
                <Select options={auditOptions} size='middle'/>
              </Item>
            </Col>
            <Col {...colCols}>
              <Item {...fieldCols} name="warningState" label="预警状态">
                <Select options={warnOptions} placeholder="请选择"/>
              </Item>
            </Col>
            <Col {...colCols}>
              <Button onClick={()=> setVisibleMarkModal(true)} icon={<HighlightOutlined/>} type="text">完成标记</Button>
            </Col>
          </Row>
          {
            showMore && (
              <>
                <Row gutter={8}>
                  <Col {...colCols}>
                    <Item {...fieldCols} name="tenantCode" label="租户">
                      <Select onChange={handleTenantChange} onDropdownVisibleChange={handleFetchTenantData}>
                        <Option value="">全部</Option>
                        {
                          tenantOptions.map(({ code, name }) => (
                            <Option key={code} value={code}>{name}</Option>
                          ))
                        }
                      </Select>
                    </Item>
                  </Col>
                  <Col {...colCols}>
                    <Item {...fieldCols} name="projectCode" label="项目中心">
                      <Select disabled={projectOptions.length === 0} onChange={handleProjectChange}>
                          <Option value="">全部</Option>
                          {
                            projectOptions.map(({ code, name }) => (
                              <Option key={code} value={code}>{name}</Option>
                            ))
                          }
                        </Select>
                    </Item>
                  </Col>
                  <Col {...colCols}>
                    <Item {...fieldCols} name="centerCode" label="所属中心">
                      <Select placeholder="请选择所属中心" disabled={centerOptions.length === 0}>
                        <Option value="">全部</Option>
                        {
                          centerOptions.map(({ code, name }) => (
                            <Option key={code} value={code}>{name}</Option>
                          ))
                        }
                      </Select>
                    </Item>
                  </Col>
                  <Col {...colCols}/>
                </Row>
                <Row>
                  <Col {...colCols}>
                    <Item {...fieldCols} name="rangeTime" label="审核时间">
                      <RangePicker locale={locale} style={{width: '100%'}}/>
                    </Item>
                  </Col>
                </Row>
              </>
            )
          }
      </Form>
      {
        visibleMarkModal && <MarkModal onClose={()=> setVisibleMarkModal(false)}/>
      }
    </div>
  );
};

export default Condition;
